import { IAuthTypeProps } from './types';
import { DataModelerConfigLabelWithInfo } from '../../DataModelerShared';
import { dataModelLabelInfoTooltipOptions } from '../../../../../components/KubitTooltip/globalTooltips';
import {
  InputField,
  TextAreaField,
  VerticalField,
} from '../../../../../components/Form';
import React from 'react';

const isChromeBrowser = !!(window as any).chrome;

const KeyPair = ({
  readOnly,
  canEditProps,
  basicInput,
  setBasicInput,
}: IAuthTypeProps) => {
  const { privateKey, username } = basicInput;
  const passwordPlaceholder = canEditProps
    ? 'Password'
    : 'Please enter the connection password';

  const setPassword = (password: string) => {
    setBasicInput({
      ...basicInput,
      password: null,
      privateKey: {
        key: basicInput.privateKey?.key || '',
        password,
      },
    });
  };

  const setKey = (key: string) => {
    setBasicInput({
      ...basicInput,
      password: null,
      privateKey: {
        password: basicInput.privateKey?.password || '',
        key,
      },
    });
  };

  const setUsername = (newUsername: string) => {
    setBasicInput({
      ...basicInput,
      username: newUsername,
    });
  };

  const keyPlainPlaceholder = canEditProps
    ? 'Please paste the contents of your private key here'
    : 'Please paste the contents of your private key here to make changes';

  // XXX autoComplete={'off'} doesn't seem to help prevent autofill in chrome, 'new-password' does the trick.
  const passwordAutoComplete = isChromeBrowser ? 'new-password' : 'off';
  return (
    <>
      <VerticalField noMargin={true}>
        <DataModelerConfigLabelWithInfo
          labelText={'User Name'}
          tooltipOption={dataModelLabelInfoTooltipOptions.connectionUsername}
        />
        <InputField
          type="text"
          value={username ?? ''}
          onChange={setUsername}
          disabled={!canEditProps}
          placeholder={'Username'}
        />
      </VerticalField>
      <VerticalField noMargin={true}>
        <DataModelerConfigLabelWithInfo
          labelText={'Private Key'}
          tooltipOption={dataModelLabelInfoTooltipOptions.connectionKeyPairKey}
        />
        <TextAreaField
          minRows={8}
          maxRows={8}
          disabled={readOnly}
          value={privateKey?.key || ''}
          onChange={setKey}
          placeholder={keyPlainPlaceholder}
        />
      </VerticalField>
      <VerticalField noMargin={true}>
        <DataModelerConfigLabelWithInfo
          labelText={'Private Key Password'}
          tooltipOption={
            dataModelLabelInfoTooltipOptions.connectionKeyPairPassword
          }
        />
        <InputField
          type="password"
          name="kubit-ds-kf34czsd"
          value={privateKey?.password ?? ''}
          onChange={setPassword}
          disabled={readOnly}
          placeholder={passwordPlaceholder}
          autoComplete={passwordAutoComplete}
        />
      </VerticalField>
    </>
  );
};

export default KeyPair;
